"use client";
import { useReportWebVitals } from "next/web-vitals";

export const WebVitals = () => {
	useReportWebVitals(metric => {
		switch (metric.name) {
			case "TTFB":
			case "FCP":
			case "LCP":
			case "FID":
			case "CLS":
				return;
		}
	});

	return null;
};
